module.exports = __webpack_public_path__ + "cd835d05865e496ff6b868655a4c8856.svg";